import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import React from 'react';

const Layout = ({ onSubmit, disabled }) => {
  const { resource } = useMetaLayoutContext();

  const handleHouseholdChange = async (value) => {
    await onSubmit(value);
  };

  return (
    <MetaControlField
      key={'householdId'}
      attr={'householdId'}
      resource={resource}
      onChange={(value) => handleHouseholdChange(value)}
      disabled={disabled}
      clearable={!!resource.attr('householdId')}
    />
  );
};

Layout.defaultProps = {
  onSubmit: null,
  disabled: false,
};

Layout.propTypes = {
  onSubmit: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Layout;
